export default "__VITE_ASSET__8oSBntPk__"